/**
 * B-556 — ekrany panelu w kontekście samoaktualizacji (część, która NIE jest lustrem aplikacji
 * instruktora: lista ekranów jest własna tej aplikacji; rdzeń reguł to `aktualizacja.ts`).
 */

/**
 * Ekrany, które wolno wymienić bez pytania: listy, mapy i widoki tylko do odczytu. Dokładne
 * ścieżki, celowo — LISTA DOZWOLONYCH: ekran dodany później jest „tylko komunikat”, dopóki ktoś
 * nie zdecyduje, że jest bezpieczny, zamiast być przeładowany pod użytkownikiem domyślnie
 * (pilnuje tego strażnik: każda trasa z `App.tsx` musi mieć jawną decyzję).
 *
 * Panel to narzędzie pracy dyspozytorów: karty bywają otwarte godzinami, a część ekranów ma stan,
 * którego żaden zapis nie trzyma (rozpoczęty wpis w dzienniku, układany grafik, edytowany formularz,
 * odpowiedź w wiadomościach, komentarz w zgłoszeniu). Takich ekranów tu NIE MA, nawet gdy
 * wyglądają na „listy” — sprawdzenie pól z tekstem to druga siatka, nie pierwsza.
 *
 * ŚWIADOMIE POZA LISTĄ: `/planner`, `/task-templates`, `/duty-log`, `/messages`, `/feedback*`,
 * `/instructors`, `/profile`, `/change-password`, `/settings/*`, cała administracja (`/admin/*` poza
 * dziennikami audytu i zgód), wszystkie ekrany edycji i zakładania (`/forms/:id`, `/forms/new/:code`,
 * `/incidents/:id`, `/reports/creator/:id`, `/admin/forms/*`) oraz ekrany logowania i publiczne.
 */
export const SAFE_ROUTES: readonly string[] = [
  '/',                // Pulpit
  '/forms/my',        // LISTA dokumentów — nie `/forms/<id>`
  '/forms/kontrole-trzezwosci', // B-655: rejestr tylko do odczytu, filtry w adresie — przeładowanie oddaje ten sam widok
  '/forms/kontrole-predkosci',  // B-675: jw. — rejestr kontroli prędkości
  '/incidents',       // LISTA zdarzeń — nie `/incidents/<id>`
  '/analytics',
  '/reports',         // LISTA raportów — nie kreator
  '/failures',
  '/disruptions',
  '/mapa-pojazdow',
  '/inspections',
  '/worktime',
  '/execution',
  '/rozklad',         // B-683 E3: rozkład jazdy tylko do odczytu — dzień, widok, filtry i otwarta służba w adresie
  '/realizacja-wozow', // B-616: realizacja planu wozów — tylko odczyt, dzień/zmiana/filtry w adresie
  '/road-cards',      // B-676: przegląd kart drogowych — filtry i widok w adresie; wpisany powód anulowania blokuje przeładowanie (przeszkoda „wpisany tekst”)
  '/board',
  '/pomoc',
  '/notifications',
  '/legal',
  '/admin/audit',
  '/admin/legal',
  '/insurance',          // Pulpit ubezpieczeń (tylko odczyt) — reszta modułu ma edycję i decyzje
  '/insurance/analytics', // Szkodowość (tylko odczyt)
];

/** `/pomoc/` → `/pomoc`, `/pomoc?x=1#y` → `/pomoc`; korzeń zostaje `/`. */
function normalizePath(pathname: string): string {
  const bare = pathname.split(/[?#]/)[0] ?? '';
  const trimmed = bare.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}

export function isSafeRoute(pathname: string): boolean {
  /* Brak ścieżki to „nie wiem, gdzie jestem”, a nie „Pulpit”. */
  if (!pathname) return false;
  return SAFE_ROUTES.includes(normalizePath(pathname));
}
